import React, { ReactNode } from "react";

interface CustumCardProps {
  children: ReactNode;
  className?: string;
}

const CustumCard = ({ children, className = "" }: CustumCardProps) => {
  return (
    <div
      className={`bg-white dark:bg-gray-900 rounded-2xl shadow-md p-6 ${className}`}
    >
      {children}
    </div>
  );
};

export default CustumCard;
